import React from 'react';
import milanoteLogoSvg from '../../assets/Logo-Milanote-Wide.svg';
import './logo.scss';
export var LogoLockup = function LogoLockup() {
  return /*#__PURE__*/React.createElement("div", {
    className: "LogoLockup"
  }, /*#__PURE__*/React.createElement("img", {
    className: "LogoLockup-logo",
    src: milanoteLogoSvg,
    alt: "Milanote Logo"
  }));
};